import { useEffect, useState } from 'react';
import { useFormik } from 'formik';
import { initialValues, validationSchema } from './formData';
import { LegalProceedingsProductProps } from './props';
import { LegalProceedingProduct } from '../../../../../../shared/types/legalProceedings/legalProceedings';
import { cleanObj } from '../../../../../../shared/utils/objects';
import { ISelect } from '../../../../../../shared/types/shared';
import { asyncGetProducts } from '../../../../../../services/product.service';
import { formatParams } from '../../../../../../shared/utils/params';

export const useLegalProceedingsProduct = ({
    data,
    onChangeData,
    onChangeFormik,
}: LegalProceedingsProductProps) => {
    const [products, setproducts] = useState<ISelect[]>([]);
    const onSubmit = (data: LegalProceedingProduct) => {
        if (onChangeData) onChangeData(cleanObj(data) || {});
    };

    const formik = useFormik({
        initialValues,
        validationSchema,
        onSubmit,
    });

    useEffect(() => {
        if (onChangeFormik) onChangeFormik(formik);
    }, [formik.values, formik.errors]);

    useEffect(() => {
        formik?.setFieldValue('bouquet', data?.bouquet || '');
    }, [data]);

    useEffect(() => {
        asyncGetProducts({ applyPqr: true }).then((items) =>
            setproducts(formatParams(items))
        );
    }, []);

    return {
        formik,
        products,
    };
};
